import { render, staticRenderFns } from "./RankingCriteriaEditCard.vue?vue&type=template&id=3bd603da&scoped=true"
import script from "./RankingCriteriaEditCard.vue?vue&type=script&lang=js"
export * from "./RankingCriteriaEditCard.vue?vue&type=script&lang=js"
import style0 from "./RankingCriteriaEditCard.vue?vue&type=style&index=0&id=3bd603da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd603da",
  null
  
)

export default component.exports